import Image from "next/image";

export function Logo({
  className,
}: {
  variant?: "color" | "white" | "mono";
  withTagline?: boolean;
  className?: string;
}) {
  return (
    <Image
      src="/images/logo-dermalife.png"
      alt="Dermalife Logo"
      width={2000}
      height={411}
      priority
      sizes="(max-width: 768px) 200px, 280px"
      className={className}
    />
  );
}
